import { dataToSend } from "../Types";
import config from "../../../config/config";

declare const window: any;

export let SetDataToSend = (paramsUrl:{
    tipo_servicio?:string;
    ref_pago:string;
    is_ref_number:string;
    canal:string;
    novum:string;
    urlcallback:string;
    extra10:string;
    indicativo:string;
    suscribir?:string;
    linea?:string;
    numero?:string;
    checkout?:string;
}) => {
    let dataToSet;
    if (paramsUrl.tipo_servicio === 'movil') {
        dataToSet = {
            nMovil: paramsUrl.ref_pago,
            tipo_servicio: paramsUrl.tipo_servicio,
            is_ref_number: paramsUrl.is_ref_number,
            canal: paramsUrl.canal,
            novum: paramsUrl.novum,
            urlcallback: paramsUrl.urlcallback,
            extra10: paramsUrl.extra10
        }
    }
    if (paramsUrl.tipo_servicio === 'corporativo') {
        dataToSet = {
            nCorporativo: paramsUrl.ref_pago,
            tipo_servicio: paramsUrl.tipo_servicio,
            is_ref_number: paramsUrl.is_ref_number,
            canal: paramsUrl.canal,
            novum: paramsUrl.novum,
            urlcallback: paramsUrl.urlcallback,
            extra10: paramsUrl.extra10
        }
    }
    if (paramsUrl.tipo_servicio === 'fijo') {
        if (paramsUrl.is_ref_number === 'false') {
            let nPrefijo = '';
            let nFijo = '';
            if (paramsUrl.ref_pago) {
                nPrefijo = paramsUrl.indicativo;
                nFijo = paramsUrl.ref_pago;
            }

            dataToSet = {
                nFijo: nFijo,
                nPrefijo: nPrefijo,
                tipo_servicio: paramsUrl.tipo_servicio,
                is_ref_number: paramsUrl.is_ref_number,
                canal: paramsUrl.canal,
                novum: paramsUrl.novum,
                urlcallback: paramsUrl.urlcallback,
                extra10: paramsUrl.extra10
            }
        } else {
            dataToSet = {
                nFactura: paramsUrl.ref_pago,
                tipo_servicio: paramsUrl.tipo_servicio,
                is_ref_number: paramsUrl.is_ref_number,
                canal: paramsUrl.canal,
                extra10: paramsUrl.extra10
            }
        }

    }
    return dataToSet
}

////////////////////////////
////////////////////////////


export let getVariableParam = (parametro:string) => {
    let results = new RegExp('[\?&]' + parametro + '=([^&#]*)').exec(window.location.href);
    if (!results) {
        return '';
    } else {

        return decodeURI(results[1])  || '';
    }
};


////////////////////////////
////////////////////////////


export const DataFromSmartLink = () => {

     let dta:dataToSend = {
        ref_pago      : getVariableParam("ref_pago"),
        tipo_servicio : getVariableParam("tipo_servicio"),
        is_ref_number : getVariableParam("is_ref_number"),
        canal         : getVariableParam("canal"),
        tipo_pago  : getVariableParam("tipo_pago"),
        novum      : getVariableParam("novum"),
        urlcallback: getVariableParam("urlcallback"),
        indicativo : getVariableParam("indicativo"),
        extra10    : getVariableParam("extra10"),

        //  DATA SUSCRIPTION ::::::
        suscribir : getVariableParam("suscribir"),
        linea     : getVariableParam("linea"),
        numero    : getVariableParam("numero"),
        checkout  : getVariableParam("checkout")
    };

    return dta;
}

//////////////////////////////////
// SET DATA FOR GET INVOICE
export const dataTorequest = (params:any,tipoFijo:any,invoiceType:any,commerce:string, typeConsult:string)=> {
    return({
        tipoFijo,
        isRefNumber : params.typeLine === 'movil' || tipoFijo === 'factura_id' ? "true" : "false",
        invoiceType : invoiceType,
        comerce     : commerce,
        paymentRef  : params.typeLine === 'movil' ? params.number : (
            params.typeInvoice === 'telefono' ? params.indicative + params.number :
            params.number
        ),
        referen     : params.referen,
        novum       : params.novum,
        typeConsult: typeConsult
    })
}

//////////////////////////////////
/// Metodo utilizado para decodificar de base64 la url solicita para redireccion por novum
export const getSanitizedUrl = (urlCallBack: any) => {
    let urlSanitized  = "";
    //Se realiza esta validacion por que cuando se cancela la transaccion del checkout se agrega el parametro ref_payco con el signo "?"
    if (urlCallBack.includes("?ref_payco")){
        const Base64FromUrl = urlCallBack.split("?ref_payco")
        urlSanitized = Base64FromUrl[0];
    }else{
        urlSanitized = urlCallBack;
    }
    return window.atob(urlSanitized);
};

export const validarReCaptcha = async () => {
    let result = true;
    /*
    try {
        await window.grecaptcha.execute(config.CaptchaKey, {
            action: 'Test',
        })
    } catch (error) {
        result = false;
    }
    */
    return result;
}

export const validarHost = (host: string) => {
    return new Promise(resolve => {
        fetch(host).then(response => {
            const { status } = response;
            if (status >= 200 && status <= 300) {
                resolve(true)
            } else {
                resolve(false)
            }
        }).catch(error => {
            resolve(false);
        })
    });
}
export const checOnlineStatus = async () => {
    let isOnline: any = true;
    const hosts = [
        config.REACT_APP_AMBIENTE
    ];
    isOnline = await validarReCaptcha();
    if (navigator.onLine && isOnline) {
        for (const host of hosts) {
            isOnline = await validarHost(host || "");
            if (!isOnline) {
                break;
            }
        }
    } else {
        isOnline = false;
    }
    return isOnline;
}


